import l10n from "@/services/l10n";
import createPlaylist from "./createPlaylist";

export default ({ tracks, active = true }) => {
  return createPlaylist({ title: l10n("SAVE_AS_PLAYLIST"), tracks, active });
};
